import { Codes, MarketplaceWorkerNotification } from '../smartsend/SmartSendSocketsModels';

export const IsSocketMessageBad = (details: MarketplaceWorkerNotification) =>
  details?.Code?.startsWith('USER-ACTION-') ||
  [
    Codes.CredentialsExpired,
    Codes.ImportThrottled,
    Codes.AuthorisationFailed,
    Codes.SetupRequired,
    Codes.WiderIssue,
    Codes.ScopeMissing,
    Codes.AutoDispatchFail
  ].includes(details?.Code);
